<template>
  <div id="new_property_setting">
    <div class="property-settings-btns-box" :style="{ marginTop: '10px' }">
      <!-- <el-button
          class="back-btn"
          @click="automaticMatching"
        >
          <img :src="icon_automatic" class="icon-img" alt="">
          {{ $t("excelConfiguration.automaticMatching") }}
        </el-button> -->
      <el-button
        icon="el-icon-document-add"
        style="width: 80px"
        size="small"
        @click="savePropertySetting()"
      >
        {{ $t("excelConfiguration.saveData") }}
      </el-button>
      <el-button type="primary" size="small" @click="initializeRow">
        <svg-icon icon-class="data-init"></svg-icon>
        {{ $t("excelConfiguration.initializeColumn") }}
      </el-button>
    </div>

    <!-- 属性设置列表 -->
    <div>
      <CustomTable
        ref="customTable"
        batch-delete
        :table-loading="tableLoading"
        :table-data="propertyData"
        :show-pagination="false"
        height="400px"
        :checkbox="true"
        :order="false"
        @handleSizeChange="handlePaginationChange"
        @handleCurrentChange="handlePaginationChange"
        @batchDeleteData="deleteSheetListData"
        @handleSelectionChange="SelectionData"
      >
        <el-table-column
          prop="serialNumber"
          width="50"
          :label="$t('excelConfiguration.serialNumber')"
        >
          <!-- <template slot-scope="scope">
            <el-input
              v-model="scope.row.serialNumber"
              size="small"
              disabled
              :placeholder="$t('excelConfiguration.serialNumber')"
            ></el-input>
          </template> -->
        </el-table-column>
        <!-- 标题列 -->
        <el-table-column prop="columnTitle" width="110" :label="$t('excelConfiguration.titleBar')">
          <template slot-scope="scope">
            <el-tooltip
              v-if="scope.row.columnTitle.length > 6"
              effect="dark"
              placement="top"
              :content="scope.row.columnTitle"
              popper-class="import_excel_tooltip"
            >
              <span>{{ scope.row.columnTitle }}</span>
            </el-tooltip>
            <span v-if="scope.row.columnTitle.length <= 6">{{ scope.row.columnTitle }}</span>
          </template>
        </el-table-column>
        <!-- 字段名称 -->
        <el-table-column prop="fieldDesc" :label="$t('excelConfiguration.fieldName')">
          <template slot-scope="scope">
            <!-- <el-input v-model="scope.row.fieldDesc" disabled :placeholder="$t('excelConfiguration.fieldName')"></el-input> -->
            <el-select
              v-model="scope.row.field"
              style="width: 100%"
              size="small"
              placeholder="请选择"
              @change="changeDatasourceData(scope.row.field, scope.row)"
            >
              <el-option
                v-for="item in datasourceData"
                :key="item.field"
                :label="item.field"
                :value="item.field"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <!-- 字段标题 -->
        <el-table-column prop="fieldCategory" :label="$t('excelConfiguration.fieldTitle')">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.fieldDesc"
              style="width: 100%"
              size="small"
              disabled
              placeholder="请选择"
            >
              <el-option
                v-for="item in datasourceData"
                :key="item.fieldDesc"
                :label="item.fieldDesc"
                :value="item.fieldDesc"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <!-- 字段类型 -->
        <el-table-column prop="fieldType" :label="$t('excelConfiguration.isItRequired')">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.fieldType"
              style="width: 100%"
              size="small"
              disabled
              placeholder="请选择"
            >
              <el-option
                v-for="item in charTypeList"
                :key="item.fieldType"
                :label="item.fieldType"
                :value="item.fieldType"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <!-- 是否必填 -->
        <el-table-column prop="required" width="110" :label="$t('excelConfiguration.isRequired')">
          <template slot-scope="scope">
            <el-select v-model="scope.row.required" size="small" placeholder="请选择">
              <el-option
                v-for="item in whetherList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <!-- 是否唯一 -->
        <!-- <el-table-column prop="uniqueKey" width="110" :label="$t('excelConfiguration.isUnique')">
            <template slot-scope="scope">
              <el-select v-model="scope.row.uniqueKey" placeholder="请选择">
                <el-option
                  v-for="item in whetherList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
          </el-table-column> -->
        <!-- 字段长度 -->
        <el-table-column
          prop="contentLength"
          width="110"
          :label="$t('excelConfiguration.charLength')"
        >
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.contentLength"
              size="small"
              controls-position="right"
              style="width: 100%"
            />
          </template>
        </el-table-column>
        <!-- 输入类型 -->
        <el-table-column
          prop="propertyType"
          width="110"
          :label="$t('excelConfiguration.inputType')"
        >
          <template slot-scope="scope">
            <el-select v-model="scope.row.propertyType" size="small" placeholder="请选择">
              <el-option
                v-for="item in inputTypeData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>

        <!-- 字典编码 -->
        <el-table-column
          width="200"
          prop="lookupCode"
          :label="$t('excelConfiguration.dictionaryEncode')"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.lookupCode"
              style="width: 100%"
              size="small"
              filterable
              :filter-method="SelectFilter"
              :disabled="scope.row.propertyType !== 'DICT'"
              placeholder="请选择"
              @change="SelectBlur"
            >
              <el-option
                v-for="item in selectFilterList"
                :key="item.dictCode"
                :label="item.dictName"
                :value="item.dictCode"
              >
                <span v-if="item.textValue"><span v-html="item.textValue"></span></span>
              </el-option>
            </el-select>
          </template>
        </el-table-column>

        <!-- 字段默认值 -->
        <!-- <el-table-column  prop="defaultValue" :label="$t('excelConfiguration.defaultValue')">
          <template slot-scope="scope">
            <el-input  v-model="scope.row.defaultValue" :placeholder="$t('excelConfiguration.defaultValue')"></el-input>
          </template>
        </el-table-column> -->
        <!-- 是否虚拟列 -->
        <el-table-column
          prop="isVirtual"
          width="120"
          :label="$t('excelConfiguration.virtualColumn')"
        >
          <template slot-scope="scope">
            <el-select v-model="scope.row.isVirtual" size="small" placeholder="请选择">
              <el-option
                v-for="item in whetherList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <!-- 数据转换 -->
        <!-- <el-table-column  prop="convertMode" :label="$t('excelConfiguration.dataConversionMethod')">
          <template slot-scope="scope">
            <el-select v-model="scope.row.convertMode" placeholder="请选择">
              <el-option
                v-for="item in dataConversionMethodData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column> -->

        <el-table-column :label="$t('public.operation')" fixed="right" width="70">
          <template slot-scope="scope">
            <!-- <el-button
              class="cursor-p"
              @click="savePropertySetting(scope.row)"
              type="text"
            >
              {{ $t("public.save") }}
            </el-button> -->
            <el-button
              size="small"
              class="cursor-p"
              style="color: red"
              type="text"
              @click="handleDelete(scope.row)"
            >
              {{ $t("common.delete") }}
            </el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column fixed="right" width="40">
          <template slot-scope="scope">
            <el-popover
              placement="bottom"
              trigger="hover"
              class="cursor-p self-popover hover_popover"
              :visible-arrow="false"
            >
              <span slot="reference">
                <i class="el-icon-more" style="transform: rotate(90deg);" />
              </span>
              <div class="self-popover-items">
                <p
                  class="self-popover-item font_14"
                  style="color: red;"
                  @click="handleDelete(scope.row)"
                >
                  {{ $t("common.delete") }}
                </p>
              </div>
            </el-popover>
          </template>
        </el-table-column> -->
      </CustomTable>
    </div>
    <!-- 删除 -->
    <delete-dialog
      :visible.sync="deleteDialogVisible"
      :content="deleteContent"
      :loading.sync="deleteLoading"
      @confirm="handleConfirmDelete"
    />
  </div>
</template>

<script>
import excel_api from "@/api/excel/excel";
import DeleteDialog from "@/components/common/Dialogs/DeleteDialog";
export default {
  name: "PropertySetting",
  components: {
    DeleteDialog
  },
  props: {
    configSetInfo: {
      type: Object,
      default: () => ({
        InterfaceTitle: "",
        sheetId: "",
        tableName: "",
        datasourceId: ""
      })
    }
  },

  data() {
    return {
      cascadeDict: [],
      saveSelectionData: [],
      sheetId: "",
      // 批量标识
      batch: false,
      deleteId: "",
      icon_save: require("@/assets/images/import-img/save.png"),
      icon_automatic: require("@/assets/images/import-img/automatic-matching.png"),
      icon_init: require("@/assets/images/import-img/init.png"),
      // 批量删除的数据源
      deleteRows: [],
      // 页头的标签
      InterfaceTitle: "属性设置",

      deleteDialogVisible: false,
      deleteContent: {
        title: "删除数据",
        description: "你确认删除选中的数据吗"
      },
      tableLoading: false,
      deleteLoading: false,
      pagination: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      // 属性列表
      propertyData: [],
      datasourceData: [],
      charTypeList: [],
      // 唯一性的确认
      whetherList: [
        {
          value: true,
          label: "是"
        },
        {
          value: false,
          label: "否"
        }
      ],
      // 数据转换方式
      dataConversionMethodData: [
        {
          value: "LOCAL",
          label: "本地"
        },
        {
          value: "SERVICE",
          label: "服务"
        }
      ],
      // 输入类型
      inputTypeData: [
        {
          value: "DICT",
          label: "字典"
        },
        {
          value: "USER",
          label: "人员"
        },
        {
          value: "DEPT",
          label: "部门"
        },
        {
          value: "ROLE",
          label: "角色"
        }
      ],
      selectFilterList: []
    };
  },

  created() {
    this.getInterfaceInformation();
    this.getCascadeDict();
  },
  methods: {
    SelectionData(data) {
      this.saveSelectionData = data;
    },
    changeDatasourceData(field, rowData) {
      this.datasourceData.map(item => {
        if (item.field === field) {
          rowData.field = item.field;
          rowData.fieldDesc = item.fieldDesc;
          rowData.fieldType = item.fieldType;
          rowData.required = item.required;
        }
      });
    },
    getCascadeDict() {
      excel_api.getCascadeDict().then(res => {
        if (res.success && res.code === 200) {
          this.cascadeDict = res.data;
          this.selectFilterList = res.data;
        } else {
          this.$message({
            message: "服务异常",
            type: "warning"
          });
        }
      });
    },

    /**
     * @description: 从地址栏获取界面标题的信息
     * @param {*}
     * @return {*}
     */
    getInterfaceInformation() {
      const { datasourceId } = this.configSetInfo;
      const { tableName } = this.configSetInfo;
      this.sheetId = this.configSetInfo.sheetId;
      this.InterfaceTitle = this.configSetInfo.InterfaceTitle;
      this.getdatasource(datasourceId, tableName);
      this.getSheetColumn(this.sheetId);
    },

    // 查询列集合
    getSheetColumn(sheetId) {
      this.tableLoading = true;
      excel_api.getSheetColumn(sheetId).then(res => {
        this.propertyData = res.data;
        this.propertyData.map((item, index) => {
          item.serialNumber = index + 1;
        });
        this.tableLoading = false;
      });
    },

    // 数据删除
    handleDelete(item) {
      this.deleteId = item.id;
      this.deleteLoading = false;
      this.deleteDialogVisible = true;
    },

    // 批量删除
    deleteSheetListData(data) {
      this.batch = true;
      this.deleteRows = data.map(res => res.id);
      this.deleteLoading = false;
      this.deleteDialogVisible = true;
    },

    // 确认删除
    handleConfirmDelete() {
      this.deleteLoading = true;
      // 接口调用完成
      if (!this.batch) {
        excel_api.deleteColumn(this.deleteId).then(res => {
          this.deleteLoading = false;
          this.deleteDialogVisible = false;
          this.getInterfaceInformation();
        });
      } else {
        const params = {
          keys: this.deleteRows
        };
        excel_api.deletebatchColumn(params).then(res => {
          this.deleteLoading = false;
          this.deleteDialogVisible = false;
          this.batch = false;
          this.getInterfaceInformation();
        });
      }
    },

    //  批量数据的保存
    savePropertySetting() {
      if (this.saveSelectionData.length === 0) {
        this.$message({
          message: "请选择需要保存的数据",
          type: "warning"
        });
        return;
      }

      excel_api.saveColumnOfproperty(this.saveSelectionData, this.sheetId).then(res => {
        if (res.success && res.code === 200) {
          this.$message({
            message: "保存成功",
            type: "success"
          });
          //  this.getInterfaceInformation()
        } else {
          this.$message({
            message: "保存失败",
            type: "warning"
          });
        }
      });
    },

    // 条数改变|页数改变
    handlePaginationChange(data) {
      this.$set(this, "pagination", data);
    },

    // 自动匹配
    automaticMatching() {
      excel_api.matchColumn(this.sheetId).then(res => {
        if (res.success && res.code === 200) {
          this.$message({
            message: "自动匹配完成",
            type: "success"
          });
          this.propertyData = res.data;
          this.propertyData.map((item, index) => {
            item.serialNumber = index + 1;
          });
        } else {
          this.$message({
            message: "自动匹配失败",
            type: "warning"
          });
        }
      });
    },

    // 初始化列
    initializeRow() {
      excel_api.initColumn(this.sheetId).then(res => {
        if (res.success) {
          this.propertyData = res.data;
          this.propertyData.map((item, index) => {
            item.serialNumber = index + 1;
          });
          this.$message({
            message: "初始化列操作成功",
            type: "success"
          });
        } else {
          this.$message({
            message: "初始化列操作失败",
            type: "warning"
          });
        }
      });
    },

    // 查询数据表集合
    getdatasource(datasourceId, tableName) {
      excel_api.getdatasource(datasourceId, tableName).then(res => {
        this.datasourceData = res.data;
        const arr = [];
        res.data.forEach(item => {
          if (arr.every(el => el.fieldType !== item.fieldType)) {
            arr.push(item);
          }
        });
        this.charTypeList = arr;
      });
    },
    //
    SelectFilter(v, t) {
      const arr = this.cascadeDict.filter(item => item.dictName.indexOf(v) !== -1);
      this.selectFilterList = arr.map(item => ({
        ...item,
        textValue: v
          ? item.dictName.replace(v, `<span style="color:#00B259">${v}</span>`)
          : item.dictName
      }));
    },

    SelectBlur() {
      this.selectFilterList = this.cascadeDict;
    }
  }
};
</script>

<style scoped lang="scss">
#new_property_setting {
  width: 100%;
  overflow: auto;
  min-height: 550px;
  .property-settings-btns-box {
    width: 100%;
    text-align: right;
    margin-bottom: 16px;
  }
}
</style>

<style  lang="scss">
#new_property_setting {
  .el-input.is-disabled .el-input__inner {
    background-color: #f9f9fb;
  }
}
.import_excel_tooltip{
  border-radius: 0 !important;
}
</style>
